/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getSurveyOptionGroups } from 'app/entities/survey-option-group/survey-option-group.reducer';
import { getEntities as getSurveySections } from 'app/entities/survey-sections/survey-sections.reducer';
import { getEntities as getSurveyInputTypes } from 'app/entities/survey-input-type/survey-input-type.reducer';
import { createEntity, getEntity, reset, updateEntity } from './survey-question.reducer';

export const SurveyQuestionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const surveyOptionGroups = useAppSelector(state => state.surveyOptionGroup.entities);
  const surveySections = useAppSelector(state => state.surveySections.entities);
  const surveyInputTypes = useAppSelector(state => state.surveyInputType.entities);
  const surveyQuestionEntity = useAppSelector(state => state.surveyQuestion.entity);
  const loading = useAppSelector(state => state.surveyQuestion.loading);
  const updating = useAppSelector(state => state.surveyQuestion.updating);
  const updateSuccess = useAppSelector(state => state.surveyQuestion.updateSuccess);

  const handleClose = () => {
    navigate(`/survey-question${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSurveyOptionGroups({}));
    dispatch(getSurveySections({}));
    dispatch(getSurveyInputTypes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.sortOrder !== undefined && typeof values.sortOrder !== 'number') {
      values.sortOrder = Number(values.sortOrder);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...surveyQuestionEntity,
      ...values,
      optionGroup: surveyOptionGroups.find(it => it.id.toString() === values.optionGroup?.toString()),
      surveySection: surveySections.find(it => it.id.toString() === values.surveySection?.toString()),
      inputType: surveyInputTypes.find(it => it.id.toString() === values.inputType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...surveyQuestionEntity,
          optionGroup: surveyQuestionEntity?.optionGroup?.id,
          surveySection: surveyQuestionEntity?.surveySection?.id,
          inputType: surveyQuestionEntity?.inputType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.surveyQuestion.home.createOrEditLabel" data-cy="SurveyQuestionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.surveyQuestion.home.createOrEditLabel">Create or edit a SurveyQuestion</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="survey-question-id"
                  label={translate('tinyMedicRestApp.surveyQuestion.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.parentId')}
                id="survey-question-parentId"
                name="parentId"
                data-cy="parentId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.questionName')}
                id="survey-question-questionName"
                name="questionName"
                data-cy="questionName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.questionSubtext')}
                id="survey-question-questionSubtext"
                name="questionSubtext"
                data-cy="questionSubtext"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.questionRequired')}
                id="survey-question-questionRequired"
                name="questionRequired"
                data-cy="questionRequired"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.answerRequired')}
                id="survey-question-answerRequired"
                name="answerRequired"
                data-cy="answerRequired"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.allowMutipleOptionSurveyAnswer')}
                id="survey-question-allowMutipleOptionSurveyAnswer"
                name="allowMutipleOptionSurveyAnswer"
                data-cy="allowMutipleOptionSurveyAnswer"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.dependentQuestionId')}
                id="survey-question-dependentQuestionId"
                name="dependentQuestionId"
                data-cy="dependentQuestionId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.dependentQuestionOptionId')}
                id="survey-question-dependentQuestionOptionId"
                name="dependentQuestionOptionId"
                data-cy="dependentQuestionOptionId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.dependentAnswerId')}
                id="survey-question-dependentAnswerId"
                name="dependentAnswerId"
                data-cy="dependentAnswerId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.sortOrder')}
                id="survey-question-sortOrder"
                name="sortOrder"
                data-cy="sortOrder"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.active')}
                id="survey-question-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.cursor')}
                id="survey-question-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.lastupdated')}
                id="survey-question-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.microSec')}
                id="survey-question-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surveyQuestion.timestampentry')}
                id="survey-question-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="survey-question-optionGroup"
                name="optionGroup"
                data-cy="optionGroup"
                label={translate('tinyMedicRestApp.surveyQuestion.optionGroup')}
                type="select"
              >
                <option value="" key="0" />
                {surveyOptionGroups
                  ? surveyOptionGroups.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="survey-question-surveySection"
                name="surveySection"
                data-cy="surveySection"
                label={translate('tinyMedicRestApp.surveyQuestion.surveySection')}
                type="select"
                required
              >
                <option value="" key="0" />
                {surveySections
                  ? surveySections.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="survey-question-inputType"
                name="inputType"
                data-cy="inputType"
                label={translate('tinyMedicRestApp.surveyQuestion.inputType')}
                type="select"
                required
              >
                <option value="" key="0" />
                {surveyInputTypes
                  ? surveyInputTypes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/survey-question" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SurveyQuestionUpdate;
